/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for VIPProfile model with nested risks
 * @export
 * @interface VIPProfile
 */
export interface VIPProfile {
    /**
     * 
     * @type {number}
     * @memberof VIPProfile
     */
    readonly id: number;
    /**
     * Full name of the VIP person
     * @type {string}
     * @memberof VIPProfile
     */
    name: string;
    /**
     * Profile picture of the VIP person
     * @type {string}
     * @memberof VIPProfile
     */
    profilePicture?: string | null;
    /**
     * Email address for contact
     * @type {string}
     * @memberof VIPProfile
     */
    email: string;
    /**
     * Contact phone number
     * @type {string}
     * @memberof VIPProfile
     */
    phoneNumber: string;
    /**
     * Professional title or position
     * @type {string}
     * @memberof VIPProfile
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof VIPProfile
     */
    readonly team: number;
    /**
     * 
     * @type {string}
     * @memberof VIPProfile
     */
    readonly riskCount: string;
    /**
     * 
     * @type {string}
     * @memberof VIPProfile
     */
    readonly activeRisks: string;
}

/**
 * Check if a given object implements the VIPProfile interface.
 */
export function instanceOfVIPProfile(value: object): value is VIPProfile {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('riskCount' in value) || value['riskCount'] === undefined) return false;
    if (!('activeRisks' in value) || value['activeRisks'] === undefined) return false;
    return true;
}

export function VIPProfileFromJSON(json: any): VIPProfile {
    return VIPProfileFromJSONTyped(json, false);
}

export function VIPProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): VIPProfile {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'profilePicture': json['profile_picture'] == null ? undefined : json['profile_picture'],
        'email': json['email'],
        'phoneNumber': json['phone_number'],
        'title': json['title'],
        'team': json['team'],
        'riskCount': json['risk_count'],
        'activeRisks': json['active_risks'],
    };
}

  export function VIPProfileToJSON(json: any): VIPProfile {
      return VIPProfileToJSONTyped(json, false);
  }

  export function VIPProfileToJSONTyped(value?: Omit<VIPProfile, 'id'|'team'|'risk_count'|'active_risks'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'profile_picture': value['profilePicture'],
        'email': value['email'],
        'phone_number': value['phoneNumber'],
        'title': value['title'],
    };
}

